<template>
    <div
        class="product-item"
        :class="{
            'product-item--refunded': isRefundable,
            'product-item--unavailable': isUnavailableAtPharmacyPoint,
            'product-item--rx': isRx,
            'product-item--product-of-the-week': dataProductOfTheWeek,
            '-list': isInListView
        }"
    >
        <div
            v-if="dataProductOfTheWeek"
            class="product-item__product-of-the-week-label"
        >
            Produkt tygodnia
        </div>
        <ul
            v-if="labels && !isRx && !dataProductOfTheWeek"
            class="product-item__labels"
        >
            <li v-for="(label, attr) in labelsCropped" :key="attr">
                <a :href="label.url">
                    <span
                        class="product-label"
                        :class="`product-label--${attr}`"
                    >
                        <span class="product-label__text">{{
                            label.name
                        }}</span>
                    </span>
                </a>
            </li>
        </ul>

        <button
            :id="`ph_catalogwishlist_${id}`"
            ref="wishlistButton"
            rel="whishlist"
            :data-product-id="id"
            :data-wishlist-add="`/wishlist/index/ajaxAdd`"
            :data-wishlist-remove="`/wishlist/index/ajaxRemove`"
            data-vue-init="add-to-wishlist"
            title="Dodaj do ulubionych"
            :class="[
                wishList ? 'wishlist-added' : '',
                isInListView ? '-list' : '',
                'btn-link product-shop__link product-options__btn product-shop__link wishlist link-wishlist wishlist-container'
            ]"
            :aria-label="`Dodaj do ulubionych produkt ${name}`"
            @click="addToWishlist"
        ></button>

        <div :class="{ '-list': isInListView }" class="product-item__img">
            <a :href="url" :title="name" class="product-image">
                <template v-if="isRx">
                    <div class="product-item__rx product-rx__info">
                        <img
                            :src="rxImage"
                            :alt="name"
                            loading="lazy"
                            height="190"
                            width="190"
                        />
                        <strong>
                            {{
                                i18n(isRefundable ? 'refunded' : 'not refunded')
                            }}
                        </strong>
                    </div>
                </template>
                <template v-else>
                    <img
                        width="190"
                        height="190"
                        :alt="name"
                        :class="{ 'product-lazy': isLazyImg }"
                        :src="
                            !isLazyImg
                                ? image
                                : `data:image/gif;base64,R0lGODlhAQABAAAAACw=`
                        "
                        :data-src="isLazyImg ? image : null"
                        :style="!isInCatalogView && imgLabelsMarginTop"
                        @error="replaceWithPlaceholder"
                    />
                </template>
                <template v-if="isUnavailableAtPharmacyPoint">
                    <div class="product-item__unavailable">
                        <div>
                            <span class="icon-wrapper">
                                <BlockedIcon width="18" height="18" />
                            </span>
                            <span>{{ i18n('Product is unavailable') }}</span>
                        </div>

                        <span
                            v-if="upsellLink"
                            class="product-item__unavailable-link"
                            data-vue-init="upsell-modal"
                            :data-url="upsellLink"
                            :data-product="name"
                        >
                            {{ i18n('See similar products') }}
                        </span>
                    </div>
                </template>
            </a>
        </div>
        <div class="mobile-column-for-row-view">
            <div class="mobile-column">
                <div
                    :class="{ '-list': isInListView }"
                    class="product-item__desc"
                >
                    <p class="product-item__name">
                        <a :href="url" :title="name">{{ name }}</a>
                    </p>
                    <div class="product-item__tags" v-text="keywords" />
                </div>
            </div>
            <div
                class="product-item__shop"
                :class="{
                    'product-item__shop--unavailable': !isAvailable,
                    '-list': isInListView
                }"
            >
                <ProductItemForm
                    v-bind="$props"
                    :unavailable-at-pharmacy-point="
                        isUnavailableAtPharmacyPoint
                    "
                    :ga-list-value="gaListValue"
                />
                <!-- eslint-disable vue/no-v-html -->
                <div
                    v-if="!isRefundable && isAvailable"
                    class="tooltip-max-price-info"
                    v-html="maxPriceInfoTooltip"
                />
                <!-- eslint-enable vue/no-v-html -->

                <!-- showWishlistPlaceholder -->
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import ProductItemForm from './ProductItemForm.vue'
import BlockedIcon from '@icons/blocked.svg'

export default {
    name: 'ProductItem',
    components: {
        ProductItemForm,
        BlockedIcon
    },
    inheritAttrs: false,
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        sku: {
            type: [String, Number],
            required: true
        },
        name: {
            type: String,
            required: true
        },
        price: {
            type: [String, Number],
            required: true
        },
        isRx: {
            type: Boolean,
            required: true
        },
        isRefundable: {
            type: Boolean,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        image: {
            type: String,
            required: true
        },
        isAvailable: {
            type: Boolean,
            default: true
        },
        isAllowedAtPharmacyPoint: {
            type: Boolean,
            default: false
        },
        hasUpsell: {
            type: Boolean,
            default: false
        },
        labels: {
            type: [Object, Array],
            default: () => ({})
        },
        gaListValue: {
            type: String,
            default: ''
        },
        dataProductOfTheWeek: {
            type: Boolean,
            default: false
        },
        keywords: {
            type: [Object, Array, String],
            default: () => ''
        },
        viewMode: {
            type: String,
            default: ''
        },
        index: {
            type: [String, Number],
            required: true
        },
        page: {
            type: [String, Number],
            required: true
        },
        wishList: {
            type: Boolean,
            default: false
        },
        addToWishlistParent: {
            type: Function,
            default: null
        },
        removeFromWishlistParent: {
            type: Function,
            default: null
        }
    },
    computed: {
        ...mapState({
            rxImage: ({ options }) => options?.category?.rxImage,
            baseUrl: ({ options }) => options?.baseUrl,
            categoryId: (state) => state.params.id,
            placeholderImage: ({ options }) =>
                options?.category?.placeholderImage
        }),
        ...mapGetters(['maxPriceInfoTooltip', 'i18n']),
        isUnavailableAtPharmacyPoint() {
            return (
                (this.userPharmacy?.is_pharmacy_point &&
                    !this.isAllowedAtPharmacyPoint) ||
                !this.isAvailable
            )
        },
        userPharmacy() {
            return this.$context.userPharmacy
        },
        upsellLink() {
            return (
                !this.isAvailable &&
                this.hasUpsell &&
                `${this.baseUrl}base/ajax/getUpsellProducts?sku=${this.sku}&catId=${this.categoryId}`
            )
        },
        imgLabelsMarginTop() {
            if (Object.keys(this.labels).length <= 1) {
                return ''
            }

            return {
                'margin-top': `${
                    15 + (Object.keys(this.labels).length - 1) * 10
                }px`
            }
        },
        isInCatalogView() {
            return true
            //return this.$root.$el.id === 'catalog-vue'
        },
        isInListView() {
            return this.viewMode === 'list'
        },
        labelsCropped() {
            return this.labels?.length > 2
                ? this.labels.slice(0, 2)
                : this.labels
        },
        isLazyImg() {
            return !(this.index in [1, 2, 3, 4] && this.page === 1)
        }
    },
    mounted() {
        this.observer = new MutationObserver((mutations) => {
            for (const m of mutations) {
                const newValue = m.target.getAttribute(m.attributeName)
                const productId = parseInt(
                    m.target.getAttribute('data-product-id')
                )
                this.$nextTick(() => {
                    const classList = newValue.split(' ')
                    if (classList.includes('wishlist-added')) {
                        this.addToWishlistParent(productId)
                    }
                    if (!classList.includes('wishlist-added')) {
                        this.removeFromWishlistParent(productId)
                    }
                })
            }
        })

        this.observer.observe(this.$refs.wishlistButton, {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ['class']
        })
    },
    beforeDestroy() {
        this.observer.disconnect()
    },
    methods: {
        replaceWithPlaceholder(el) {
            el.target.src = this.placeholderImage
        },
        addToWishlist(event) {
            if (typeof this.$apteline !== 'undefined' && event.currentTarget) {
                this.$apteline.wishlist.OnWishlistButtonClick(
                    event.currentTarget
                )
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.product-list__grid {
    .product-item {
        @media #{$media-xs} {
            min-width: 152px;
            max-width: 250px;
            width: 100%;
            flex-grow: 1;
        }
    }
}

.product-item {
    $b: &;
    &:not(#{$b}--rx) {
        #{$b}__img {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
.product-options {
    &__icon {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        border-radius: 50%;
        box-shadow: 0px 2px 15px rgba(183, 189, 196, 0.570852);
        margin-bottom: 7px;
    }
}
</style>
